/* unplugin-vue-components disabled */import script from "./DynamicParams2.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicParams2.vue?vue&type=script&setup=true&lang=js"

import "./DynamicParams2.vue?vue&type=style&index=0&id=6a95c3ea&lang=scss"

const __exports__ = script;

export default __exports__